import { Component, Input, input, InputSignal, output } from '@angular/core';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { ParcelAppEntityParcelWrite } from '../../../../../../../openapi';
import { AccordionGroupComponent } from '../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../common/accordion-item/accordion-item.component';

@Component({
  selector: 'app-parcels-preview',
  standalone: true,
  imports: [
    AlertComponent,
    LabelComponent,
    CommonModule,
    AccordionGroupComponent,
    AccordionItemComponent
  ],
  templateUrl: './parcels-preview.component.html'
})
export class ParcelsPreviewComponent {

  @Input()
  public expanded: boolean = true;

  @Input()
  public detailedInformation: boolean = false;

  @Input()
  public showIsEntireParcelCoveredByPlan: boolean = false;

  @Input()
  public planName: boolean = false;

  @Input()
  public landUse: boolean = false;

  @Input()
  public access: boolean = false;

  @Input()
  public parcelId: boolean = false;

  public showActions = input(false);

  public canEdit = input(true);

  public parcels: InputSignal<ParcelAppEntityParcelWrite[]> = input<ParcelAppEntityParcelWrite[]>([]);

  public onRemove = output<number>();

  public onEdit = output<{ v: ParcelAppEntityParcelWrite, i: number }>();

}
